import { isFreePreset } from '@/hooks/useFreePresets';
import { isOnboardingSession } from '@/utils/environment/onboardingSession';

import type { FreeQuotaReason } from '@/requests/magic-flow/submitWebHook';

/**
 * Whether this run generates for free, and on which grounds — the single
 * answer the credits gate and the submit both read, so the gate can never skip
 * a charge the submit then bills, or vice versa.
 *
 * `undefined` means a normal paid run.
 *
 * Onboarding wins when both apply: that session is already entitled to free
 * runs, and its 429 has a side effect the `free` case doesn't
 * (`endOnboardingSession`).
 *
 * Async because the free-preset list is a remote setting. It resolves from a
 * module cache after the first fetch (the cost displays warm it on mount), and
 * waiting is the point on a cold cache — guessing "paid" would charge credits
 * for a preset that is meant to be free.
 */
const resolveFreeQuotaReason = async (
  presetSlug?: string | null
): Promise<FreeQuotaReason | undefined> => {
  if (isOnboardingSession()) return 'onboarding';
  if (await isFreePreset(presetSlug)) return 'free';

  return undefined;
};

export default resolveFreeQuotaReason;
